import { OscarClient } from '~/api/oscar.js'

export function useOscarClient(locale) {
  const config = useRuntimeConfig()
  const resolvedLocale = locale ?? 'de'
  const url = (false && config.serverApiBase)
    ? config.serverApiBase
    : (config.public.apiBase ?? '')

  return new OscarClient(url, resolvedLocale)
}
